import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

function formatError(detail) {
  if (!detail) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || "").join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#1A1A1A] px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm rounded-3xl bg-white p-8"
      >
        <img src="/logo-saipass.png" alt="SAIPASS Beneficios" className="mb-5 h-11 w-auto" />
        <h1 className="font-display text-3xl font-black tracking-tight">Panel de administración</h1>
        <p className="mt-1 text-sm text-[#5C5C5C]">SAIPASS Beneficios · acceso solo para administradores.</p>

        <form onSubmit={submit} className="mt-6 flex flex-col gap-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Correo"
            data-testid="admin-email-input"
            className="rounded-xl border border-black/10 bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#E54D2E]"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Contraseña"
            data-testid="admin-password-input"
            className="rounded-xl border border-black/10 bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#E54D2E]"
            required
          />
          {error && <p className="text-sm font-semibold text-[#E54D2E]" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-2 flex items-center justify-center gap-2 rounded-xl bg-[#1A1A1A] py-3.5 font-bold text-white disabled:opacity-60"
          >
            {loading && <Loader2 size={18} className="animate-spin" />}
            Iniciar sesión
          </button>
        </form>
      </motion.div>
    </div>
  );
}
